import axios from "axios";
import Swal from "sweetalert2";

import { transactionID } from "../helpers";

export async function getAccountDetailsRequest({ msisdn, accessToken }) {
  if (localStorage.getItem("clientInfo") === null) {
    return false;
  }

  return axios
    .post(
      `https://www.pagtel.com.br/Hub360Correios/v2/AccountDetails`,
      {
        transactionID: transactionID("AAA"),
        MSISDN: msisdn,
      },
      { headers: { Authorization: "Bearer " + accessToken } }
    )
    .then((res) => {
      switch (res.data.code) {
        case "P00":
          // console.log(res.data);
          let accountDetails = {
            msisdn: res.data.msisdn,
            networkID: res.data.networkID,
            validityDate: res.data.validityDate,
            currBalance: res.data.currBalance,
            languageID: res.data.languageID,
            planID: res.data.planID,
            simStatus: res.data.simStatus,
          };

          localStorage.setItem(
            "accountDetails",
            JSON.stringify(accountDetails)
          );

          return {
            currBalance: res.data.currBalance,
            phone: res.data.msisdn,
          };
        default:
          Swal.fire({
            title: "Erro!",
            text: res.data.message,
            type: "error",
          });
          break;
      }
    })
    .catch((res) => {
      Swal.fire({
        title: "Erro!",
        text: "Erro ao conectar com o servidor",
        type: "error",
      });
      return { redirect: true };
    });
}
